<template>
    <b-modal
            :id="modalId"
            :visible="show"
            @hidden="hideEvents"
            title="Update client property designation"
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>
        <b-form-group
                label="Client property designation:"
                label-size="sm"
        >
            <b-form-input
                    v-model="form.clientPropertyDesignation.value"
            >
            </b-form-input>
        </b-form-group>
        <template slot="modal-footer">
            <b-button
                    @click="hideModal"
                    variant="outline-secondary">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                :disabled="disabled"
                @click="update"
                class="btn-arrow"
                variant="primary"
            >
                Update properties
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import CaretIcon from '@/components/Form/CaretIcon';
import ModalMixin from '@/components/Modal/ModalMixin';
import Property from '@/services/Property/Property';

export default {
  name: 'Update-Designation-Modal',
  components: {
    CaretIcon,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'updateDesignationModal',
      loading: false,
      form: {
        clientPropertyDesignation: {
          value: '',
        },
      },
    };
  },
  computed: {
    disabled() {
      return this.form.clientPropertyDesignation.value === '';
    },
  },
  methods: {
    async update() {
      this.loading = true;

      const params = {
        propertyIds: this.nodeIds,
        clientPropertyDesignation: this.form.clientPropertyDesignation.value,
      };

      try {
        await Property.updateClientDesignation(params);

        const title = 'Properties updated';
        const text = `All ${this.nodeIds.length} properties have been updated`;
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.$emit('refresh-all');
        this.hideModal();
      } catch (e) {

      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
</style>
